import React, { useState, useEffect } from 'react';
import './HostelCard.css';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TextField,
  Alert
} from '@mui/material';

import { SITE_CONFIG } from "../../config/siteConfig";
import HotelIcon from '@mui/icons-material/Hotel';
import CallIcon from '@mui/icons-material/Call';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import HostelDetails from '../HostelDetails/HostelDetails';
import BookingFormDialog from '../HostelDetails/BookingFormDialog';
import { Tooltip } from '@mui/material';

import axios from 'axios';
import { API_BASE_URL } from '../../config';

const HostelCard = ({
  image,
  name,
  city,
  hostelId,
  totalBedsAvailableCount,
  phone,gender,searchDates,propertyType
}) => {
  const [openDetails, setOpenDetails] = useState(false);
  const [openScheduleVisit, setOpenScheduleVisit] = useState(false);
  const [openRequestCallBack, setOpenRequestCallBack] = useState(false);
  const [openBooking, setOpenBooking] = useState(false);

  // Form states
  const [visitorName, setVisitorName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [plannedVisitDateTime, setPlannedVisitDateTime] = useState('');
  const [visitorLocation, setVisitorLocation] = useState('');
  const [visitorQuery, setVisitorQuery] = useState('');

  const [requesterName, setRequesterName] = useState('');
  const [requesterLocation, setRequesterLocation] = useState('');
  const [requesterQuery, setRequesterQuery] = useState('');

  // Status
  const [scheduleStatus, setScheduleStatus] = useState({
    message: '',
    severity: 'success',
  });

  const [callbackStatus, setCallbackStatus] = useState({
    message: '',
    severity: 'success',
  });

  const isMobile = window.innerWidth < 600;

  /* ---------------- RESET FORMS ---------------- */
  useEffect(() => {
    if (openScheduleVisit) {
      setScheduleStatus({ message: '', severity: 'success' });
      setVisitorName('');
      setMobileNumber('');
      setVisitorLocation('');
      setVisitorQuery('');
      setPlannedVisitDateTime('');
    }
  }, [openScheduleVisit]);

  useEffect(() => {
    if (openRequestCallBack) {
      setCallbackStatus({ message: '', severity: 'success' });
      setRequesterName('');
      setMobileNumber('');
      setRequesterLocation('');
      setRequesterQuery('');
    }
  }, [openRequestCallBack]);



  /* ---------------- API CALLS ---------------- */

  const handleScheduleSubmit = async () => {
    if (!visitorName || !mobileNumber) {
      setScheduleStatus({
        message: 'Please enter name and mobile number',
        severity: 'warning',
      });
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/public/createHostelVisitSchedule`, {
        hostelVisitScheduleDTO: {
          hostelId,
          visitorName,
          mobileNumber,
          visitorQuery,
          visitorLocation,
          plannedVisitDateTime
        }
      });

      setScheduleStatus({
        message: 'Visit scheduled successfully',
        severity: 'success',
      });
    } catch {
      setScheduleStatus({
        message: 'Failed to schedule visit. Please try again.',
        severity: 'error',
      });
    }
  };

  const handleRequestCallBackSubmit = async () => {
    if (!requesterName || !mobileNumber) {
      setCallbackStatus({
        message: 'Please enter name and mobile number',
        severity: 'warning',
      });
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/public/createHostelRequestCallback`, {
        hostelRequestCallbackDTO: {
          hostelId,
          requesterName,
          mobileNumber,
          requesterQuery,
          requesterLocation
        }
      });

      setCallbackStatus({
        message: 'Callback request submitted successfully',
        severity: 'success',
      });
    } catch {
      setCallbackStatus({
        message: 'Failed to submit callback request. Please try again.',
        severity: 'error',
      });
    }
  };
const handleWhatsAppClick = (phone, name, city) => {
  if (!phone) return;

  const message = `Hi, I'm looking for accommodation in ${city}.
Hostel: ${name}
Please share price, availability & facilities.`;

  const url = `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;

  window.open(url, '_blank');
};
  /* ---------------- CALL CLICK ---------------- */
 const handleCallClick = (phone) => {
  if (!phone) return;

  // Trigger phone dial
  window.location.href = `tel:${phone}`;

  console.log("Call clicked:", phone);
};
const normalizedPropertyType = propertyType?.toUpperCase();

const propertyTypeLabels = {
  HOSTEL: "Hostel",
  PG: "PG",
  HOTEL: "Hotel",
  HOMESTAY: "Homestay",
  RESORT: "Resort",
  MICROSTAY: "Microstay",
};

const displayPropertyType =
  propertyTypeLabels[normalizedPropertyType] || "Property";

const showGender =
  normalizedPropertyType === "HOSTEL" ||
  normalizedPropertyType === "PG";  
  return (
    <div className="hotel-card">
      <img src={image} alt={name} />

      <div className="card-content">
		<h3 className="hostel-title">
  <span className="hostel-name">{name}</span>

  <span className="badges">
    <span className="property-badge">
      {displayPropertyType}
    </span>

    {showGender && gender && (
  <span className={`gender-badge ${gender}`}>
    {gender === "male" && "Boys"}
    {gender === "female" && "Girls"}
    {gender === "unisex" && "Unisex"}
  </span>
)}
  </span>
</h3>
     <p>{city}</p>

        {/* Beds */}
        <div className="beds-wrapper">
          <div className={`beds ${totalBedsAvailableCount > 0 ? 'available' : 'full'}`}>
            🛏️ {totalBedsAvailableCount > 0
              ? `${totalBedsAvailableCount} Beds Available`
              : 'Fully Occupied'}
          </div>

          {totalBedsAvailableCount > 0 && totalBedsAvailableCount <= 3 && (
            <div className="few-left">⚡ Few beds left!</div>
          )}
        </div>

        {/* ACTIONS */}
        <div className="card-actions">

          {/* PRIMARY */}
          <div className="primary-actions">
		 
            <Button 
			  size="small"
              variant="contained"
              onClick={() => setOpenDetails(true)}
              fullWidth
            >
              View Details
            </Button>

            <Button 
			 size="small"
              variant="contained"
              color="primary"
              startIcon={<HotelIcon />}
              onClick={() => setOpenBooking(true)}
              fullWidth
            >
              Book Now
            </Button>
          </div>

          {/* SECONDARY */}
          <div className="secondary-actions">

  {/* Visit */}
   {SITE_CONFIG.features?.listingActions?.visit && (
  <Button
    size="small"
    variant="outlined"
    onClick={() => setOpenScheduleVisit(true)}
    disabled={totalBedsAvailableCount === 0}
  >
    Visit
  </Button>
)}
  {/* Callback */}
  {SITE_CONFIG.features?.listingActions?.callBack && (
  <Button
    size="small"
    variant="outlined"
    onClick={() => setOpenRequestCallBack(true)}
  >
    Callback
  </Button>
)}
  {/* CALL */}
  <Tooltip title="Call" arrow>
    <Button
      size="small"
      variant="contained"
      color="success"
      onClick={() => handleCallClick(phone)}
      disabled={!phone}
      sx={{ minWidth: 0 }}
    >
      <CallIcon fontSize="small" />
    </Button>
  </Tooltip>

  {/* WHATSAPP */}
  <Tooltip title="WhatsApp" arrow>
    <Button
      size="small"
      variant="contained"
      onClick={() => handleWhatsAppClick(phone, name, city)}
      disabled={!phone}
      sx={{
        minWidth: 0,
        backgroundColor: '#25D366',
        '&:hover': { backgroundColor: '#1ebe5d' }
      }}
    >
      <WhatsAppIcon fontSize="small" />
    </Button>
  </Tooltip>

</div>

        </div>
      </div>

      {/* DETAILS */}
      <Dialog open={openDetails} fullScreen={isMobile} fullWidth maxWidth="md">
        <DialogTitle
  sx={{
    position: 'relative',
    pr: 6,
    pb: 3,
  }}
>
  <span>{name} – {city}</span>

  {/* Floating Close Button */}
 <IconButton
  onClick={() => setOpenDetails(false)}
  sx={{
    position: 'absolute',
    top: 10,
    right: 16,

    width: 40,
    height: 40,
    borderRadius: '50%',

    backgroundColor: 'rgba(0,0,0,0.04)',
    border: '1px solid rgba(0,0,0,0.08)',

    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.08)',
    },

    fontSize: '20px',
    fontWeight: 500,
    color: '#333',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  ×
</IconButton>
</DialogTitle>

        <DialogContent dividers>
          <HostelDetails hostelId={hostelId} />
        </DialogContent>
      </Dialog>

      {/* SCHEDULE VISIT */}
      <Dialog open={openScheduleVisit} fullScreen={isMobile} fullWidth maxWidth="sm">
        <DialogTitle sx={{ position: 'relative', pr: 6 }}>
          Schedule Visit
          <IconButton
  onClick={() => setOpenScheduleVisit(false)}
  aria-label="close"
  sx={{
    position: 'absolute',
    top: 10,
    right: 16,

    width: 40,
    height: 40,
    borderRadius: '50%',

    backgroundColor: 'rgba(0,0,0,0.04)',
    border: '1px solid rgba(0,0,0,0.08)',

    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.08)',
    },

    fontSize: '20px',
    fontWeight: 500,
    color: '#333',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  ×
</IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {scheduleStatus.message && (
            <Alert severity={scheduleStatus.severity} sx={{ mb: 2 }}>
              {scheduleStatus.message}
            </Alert>
          )}

          <TextField fullWidth label="Name" margin="dense"
            onChange={e => setVisitorName(e.target.value)} />
          <TextField fullWidth label="Mobile Number" margin="dense"
            onChange={e => setMobileNumber(e.target.value)} />
          <TextField fullWidth type="datetime-local" margin="dense"
            InputLabelProps={{ shrink: true }}
            onChange={e => setPlannedVisitDateTime(e.target.value)} />
          <TextField fullWidth label="Location" margin="dense"
            onChange={e => setVisitorLocation(e.target.value)} />
          <TextField fullWidth label="Query" margin="dense"
            onChange={e => setVisitorQuery(e.target.value)} />
        </DialogContent>

        <DialogActions>
          <Button variant="contained" onClick={handleScheduleSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* CALLBACK */}
      <Dialog open={openRequestCallBack} fullScreen={isMobile} fullWidth maxWidth="sm">
        <DialogTitle sx={{ position: 'relative', pr: 6 }}>
          Get Call Back
          <IconButton
  onClick={() => setOpenRequestCallBack(false)}
  aria-label="close"
  sx={{
    position: 'absolute',
    top: 10,
    right: 16,

    width: 40,
    height: 40,
    borderRadius: '50%',

    backgroundColor: 'rgba(0,0,0,0.04)',
    border: '1px solid rgba(0,0,0,0.08)',

    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.08)',
    },

    fontSize: '20px',
    fontWeight: 500,
    color: '#333',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  ×
</IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {callbackStatus.message && (
            <Alert severity={callbackStatus.severity} sx={{ mb: 2 }}>
              {callbackStatus.message}
            </Alert>
          )}

          <TextField fullWidth label="Name" margin="dense"
            onChange={e => setRequesterName(e.target.value)} />
          <TextField fullWidth label="Mobile Number" margin="dense"
            onChange={e => setMobileNumber(e.target.value)} />
          <TextField fullWidth label="Location" margin="dense"
            onChange={e => setRequesterLocation(e.target.value)} />
          <TextField fullWidth label="Query" margin="dense"
            onChange={e => setRequesterQuery(e.target.value)} />
        </DialogContent>

        <DialogActions>
          <Button variant="contained" onClick={handleRequestCallBackSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* BOOKING */}
      <BookingFormDialog
        open={openBooking}
        onClose={() => setOpenBooking(false)}
        hostelId={hostelId}
      searchDates={searchDates}
      />
    </div>
  );
};

export default HostelCard;